import React, {useMemo} from "react"
import {useTranslation} from "react-i18next"
import {KlassDropdownProps} from "../Select"
import {KlassDropdown} from "../inputs"

type Props = Partial<KlassDropdownProps> & {}

const BooleanSelect: React.FC<Props> = ({value, ...props}) => {
    const {t} = useTranslation(["common"])

    const options = useMemo(
        () => [
            {id: true, name: "Yes"},
            {id: false, name: "No"}
        ],
        []
    )

    return (
        <KlassDropdown
            {...props}
            options={options}
            valueKey="id"
            labelKey="name"
            value={typeof value === "boolean" ? options.find((option) => option.id === value) : value}
        />
    )
}

export default BooleanSelect
